export const config = {
  ADMIN_ENDPOINT: process.env.REACT_APP_ADMIN_ENDPOINT,
  CLIENT_ENDPOINT: process.env.REACT_APP_CLIENT_ENDPOINT,
  STATIC_FILE_ENDPOINT: process.env.REACT_APP_STATIC_FILE_ENDPOINT,
  AUTO_LOGOUT_SECONDS: Number(process.env.REACT_APP_AUTO_LOGOUT_SECONDS),
  VERSION_FILE_MAX_SIZE: Number(process.env.REACT_APP_VERSION_FILE_MAX_SIZE),
};
